import appbar from './appbar.json';
import common from './common.json';
import directoriesList from './directories-list.json';
import directory from './directory.json';
import displaySettings from './display-settings.json';
import settings from './settings.json';
import sidebar from './sidebar.json';

export default {
  common,
  directoriesList,
  sidebar,
  appbar,
  displaySettings,
  settings,
  directory,
};
